import Link from "next/link";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-8 py-12">
          {/* Description */}
          <div className="flex-1 max-w-xl">
            <p className="text-sm text-muted-foreground/80 leading-relaxed">
              {currentYear} — A{" "}
              <span className="text-foreground font-light">
                <Link href="https://euler.software" target="_blank" rel="noopener noreferrer">
                  euler.software
                </Link>
              </span>{" "}
              initiative to build a stronger community on the Infios partners ecosystem.
            </p>
          </div>

          {/* Links */}
          <nav className="flex flex-col sm:flex-row gap-6 text-sm">
            <Link href="https://www.linkedin.com/groups/10126002/" target="_blank" className="text-muted-foreground hover:text-foreground transition-colors duration-200">
              LinkedIn Group
            </Link>
            <Link href="https://chat.whatsapp.com/HB7ZhH1ZXaSADXrGq0lNgs" target="_blank" className="text-muted-foreground hover:text-foreground transition-colors duration-200">
              WhatsApp Channel
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
